import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDoubleLeft = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M18.294 18.707a1 1 0 0 0 1.413-1.412L14.407 12l5.3-5.295a.998.998 0 1 0-1.413-1.413l-6.007 6.002a.998.998 0 0 0 0 1.412l6.007 6.002Z", fill: color }),
        React.createElement("path", { d: "M10.3 18.707a1 1 0 0 0 1.412-1.412L6.413 12l5.3-5.295A.998.998 0 1 0 10.3 5.292l-6.006 6.002a.998.998 0 0 0 0 1.412l6.006 6.002Z", fill: color })));
};
export default factorySvgIcon(SvgArrowDoubleLeft);
//# sourceMappingURL=SvgArrowDoubleLeft.js.map